import { render, staticRenderFns } from "./AllReports.vue?vue&type=template&id=38da86f6"
import script from "./AllReports.vue?vue&type=script&lang=ts"
export * from "./AllReports.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports